var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83325 0C1.00513 0 0.333252 0.671875 0.333252 1.5V10.5C0.333252 11.3281 1.00513 12 1.83325 12H2.83325C3.66138 12 4.33325 11.3281 4.33325 10.5V1.5C4.33325 0.671875 3.66138 0 2.83325 0H1.83325ZM7.83325 0C7.00513 0 6.33325 0.671875 6.33325 1.5V10.5C6.33325 11.3281 7.00513 12 7.83325 12H8.83325C9.66138 12 10.3333 11.3281 10.3333 10.5V1.5C10.3333 0.671875 9.66138 0 8.83325 0H7.83325Z",
    fill: "#6D6584"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.006257aa60b47a67ad5c24c114922b14.svg";
export { ForwardRef as ReactComponent };